
  import { Vue, Component, Prop } from "vue-property-decorator";

  import { NO_INFORMATION } from "@/data/placeholders";

  @Component({})
  export default class InformationSection extends Vue {
    @Prop({ type: String, required: true }) readonly title!: string;
    @Prop({ type: String, default: "" }) readonly content!: string;

    placeholder: string = NO_INFORMATION;
  }
